import React from 'react'
import { Link } from 'react-router-dom'
// Components
import LinksMap from '../components/LinksMap'
import PageTransition from '../components/PageTransition'
// CSS
import '../assets/css/form.css'
import '../assets/css/login-signup.css'

export default function Signup() {
  return (
    <div className='signup_page'>
      <PageTransition />
      <LinksMap linksArr={[{name: 'Home', path:'/', active: false}, {name: 'Account', path: '/account', active: false}, {name: 'Signup', path: '/login', active: true}]} pageName="Signup" />

      <form className='signup_form default'>
        <div className='form_header'>
          <p>Signup to your account to buy products and explore the site.</p>
        </div>

        <div className='inputs'>
          <div className='input_container'>
            <label for='email'>Full Name</label>
            <input type='text' id='full-name' placeholder='Ex: John Doe' />
          </div>

          <div className='input_container'>
            <label for='email'>Email</label>
            <input type='email' id='email' placeholder='Ex: example@example.com' />
          </div>

          <div className='input_container'>
            <label for='password'>Password</label>
            <input type='password' id='password' placeholder='Enter your password' />
          </div>

          <div className='input_container'>
            <label for='confirm-password'>Confirm Password</label>
            <input type='password' id='confirm-password' placeholder='Confirm your password' />
          </div>
        </div>

        <div className='actions'>
          <button type='submit' className='submit_btn'>Signup</button>
        </div>

        <div className='sl_link'>
          <span>Already have an account?</span>
          <Link to='/login'><button>Login</button></Link>
        </div>
      </form>
    </div>
  )
}
